<!--
 * @Author: QWX
 * @Description:付款信息汇总
 * @LastEditors: QWX
 * @LastEditTime: 2021-12-28 19:08:11
-->
<template>
  <div>
    <el-card class="m-b">
      <div slot="header">
        <span class="saas-card-header-name">付款信息汇总</span>
      </div>
      <div class="paymentInfo-content">
        <div class="paymentInfo-paid">
          <p class="title">已付金额(元):</p>
          <p class="finalCount">
            <template v-for="(item, index) in totalPay" >
              <i class="divider" :key="index" v-if="index !== 0"></i>
              <span class="rmb" :key="index">{{item.money | $zlFiltersMoneyFormat}}</span>{{item.currencyCh}}
            </template>
          </p>
        </div>
        <div>
          <p class="title">剩余应付(元):</p>
          <p class="finalCount">
            <template v-for="(item, index) in remindPay" >
              <i class="divider" :key="index" v-if="index !== 0"></i>
              <span class="rmb" :key="index">{{item.money | $zlFiltersMoneyFormat}}</span>{{item.currencyCh}}
            </template>
          </p>
        </div>
      </div>
    </el-card>
    <el-card>
      <div slot="header" >
        <span class="saas-card-header-name">实际付款记录</span>
      </div>
      <div class="paymentInfo-content">
        <paymentRecords
          :paymentTableData="paymentList"
          :currencyColumns="currencyColumns"
          :accountMoney="JSON.parse(this.baseInfo.accountMoney || '[]')"
          :isRecord="isRecord"/>
      </div>
    </el-card>
  </div>
</template>

<script>
import paymentRecords from '@/components/reconciliationAndSettlement/paymentRecords'
export default {
  components: {
    paymentRecords
  },
  props: {
    baseInfo: {
      type: Object,
      default: () => ({})
    },
    paymentList: {
      type: Array,
      default: () => []
    },
    currencyColumns: {
      type: Array,
      default: () => []
    },
    isRecord: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    totalPay() {
      const arr = []
      const map = new Map()
      JSON.parse(this.baseInfo.totalPay || '[]').map((p, index) => {
        if (map.has(p.currencyCh)) {
          arr[map.get(p.currencyCh)].money = this.$zl.util.add(arr[map.get(p.currencyCh)].money, p.money)
        } else {
          map.set(p.currencyCh, arr.length)
          arr.push(p)
        }
      })
      return arr
    },
    remindPay() {
      const arr = []
      const map = new Map()

      JSON.parse(this.baseInfo.accountMoney || '[]').map(p => {
        const obj = this.totalPay.find(i => i.currencyCh === p.currencyCh)
        if (obj) {
          p.money = this.$zl.util.subtract(p.money, obj.money)
        }
        // 合并相同币种
        if (map.has(p.currencyCh)) {
          arr[map.get(p.currencyCh)].money = this.$zl.util.add(arr[map.get(p.currencyCh)].money, p.money)
        } else {
          map.set(p.currencyCh, arr.length)
          arr.push(p)
        }
      })
      return arr
    }
  }
}
</script>

<style lang="scss" scoped>
.paymentInfo-content{
  padding-left: 20px;
  .title{
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 20px;
    margin-bottom: 4px;
  }
   .paymentInfo-paid{
     margin-bottom: 24px;
      .finalCount span{
         color: #000000A6;
      }
   }
}
</style>
